import { CustomProxy } from '@unipile/types';
import { useMemo, useState } from 'react';
import { useCallback } from 'react';
import { LocationConfigContext, LocationConfigState } from '../../context/LocationConfigContext';

export function LocationConfigProvider({ children }: { children: React.ReactNode }) {
  const [locationConfig, setLocationConfigState] = useState<LocationConfigState>({});

  const setLocationConfig = useCallback(
    (provider: string, config: { custom_proxy?: CustomProxy; auto_proxy_config?: { country?: string } }) => {
      setLocationConfigState((prev) => ({
        ...prev,
        [provider]: config,
      }));
    },
    [],
  );

  const getLocationConfig = useCallback(
    (provider: string) => {
      return locationConfig[provider] || { custom_proxy: undefined, auto_proxy_config: undefined };
    },
    [locationConfig],
  );

  const clearLocationConfig = useCallback((provider: string) => {
    setLocationConfigState((prev) => {
      const newState = { ...prev };
      delete newState[provider];
      return newState;
    });
  }, []);

  const value = useMemo(
    () => ({
      locationConfig,
      setLocationConfig,
      getLocationConfig,
      clearLocationConfig,
    }),
    [locationConfig, setLocationConfig, getLocationConfig, clearLocationConfig],
  );

  return <LocationConfigContext.Provider value={value}>{children}</LocationConfigContext.Provider>;
}
